import { v4 as uuidv4 } from 'uuid';

import dateService from '@gem/services/date-service';

import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { Payload } from 'STORE/Messages/Message/Payload/Payload';
import { Quote } from 'STORE/Messages/Message/Quote/Quote';

interface ICreateFakeMessageData {
  groupId: string;
  payload: Payload;
  clientUuid?: string;
  clientTime?: number;
  repliedMessage?: ChatMessage;
  quote?: Quote;
}

export function createFakeMessage(data: ICreateFakeMessageData): ChatMessage | null {
  const {
    groupId,
    payload,
    clientUuid = uuidv4(),
    clientTime = dateService.now().getTime(),
    repliedMessage,
    quote,
  } = data;

  const group = Entities.GroupsStore.getGroupById(groupId);
  if (!group) {
    return null;
  }

  return new ChatMessage(
    {
      id: clientUuid,
      clientTime,
      clientUuid,
      groupId: groupId,
      senderId: Entities.usersStore.Me.id,
      repliedMessageId: repliedMessage && repliedMessage.id,
      repliedMessage: repliedMessage,
      quote,
      payload: payload.toJSON(),
    },
    group.messagesStore
  );
}
